import { useEffect, useState } from "react";
import type { RJSFSchema } from "@rjsf/utils";
import Api from "@/services/Api";

const useGlobalDefs = () => {
  const [globalDefs, setGlobalDefs] = useState<RJSFSchema>({});
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    Api.getGlobalDefinitions()
      .fetchDirect({})
      .then((res) => {
        setGlobalDefs(res);
        setFetching(false);
      });
  }, []);
  return { globalDefs, fetching };
};

export default useGlobalDefs;
